import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';

import style from './Checkbox.module.scss';

export default function Checkbox(props) {
  const {
    checked,
    disabled,
    partial,
    label,
    onChange,
    className,
    svgStyle,
    ...otherProps
  } = props;

  // using classnames to avoid a bunch of if-cases
  // there are 6 cases in total.
  // class order is guaranteed, see: https://github.com/JedWatson/classnames/issues/112
  const checkboxState = classnames({
    disabled,
    unchecked: !checked && !partial,
    checked: checked && !partial,
    partial,
  });

  return (
    <div
      aria-checked={!partial ? checked.toString() : 'mixed'}
      className={classnames(className, style.wrapper)}
      onClick={!disabled ? onChange : noop}
      onKeyPress={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault(); // suppress scrolling on space
          return onChange(e);
        }
        return null;
      }}
      role="checkbox"
      tabIndex={disabled ? undefined : '0'}
      {...otherProps}
    >
      <img
        className={style.svg}
        src={`assets/images/${checkboxState}.svg`}
        alt=""
      />
      {label && <label className={style.label}>{label}</label>}
    </div>
  );
}

Checkbox.propTypes = {
  /**
   * checked state
   */
  checked: PropTypes.bool,
  /**
   * disabled state
   */
  disabled: PropTypes.bool,
  /**
   * partially checked state. setting this true overrides `value`
   */
  partial: PropTypes.bool,
  /**
   * label node to place beside the checkbox
   */
  label: PropTypes.node,
  /**
   * function to invoke when checked state changes
   */
  onChange: PropTypes.func.isRequired,
  /**
   * class to add to the element
   */
  className: PropTypes.string,
  /**
   * `style` object for the svg
   */
  svgStyle: PropTypes.shape({}),
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  partial: false,
  label: null,
  className: '',
  svgStyle: {},
};

Checkbox.displayName = 'Checkbox';
